<template>

    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col cols="12">
                <div class="pa-2 rounded elevation-1 bg-white">
                    <div>
                        <router-link :to="{ name: 'Home', params: { base_module: mainStore.module.base } }">
                            <v-btn density="compact" variant="outlined" color="primary-dark" text>
                                <v-icon>mdi-arrow-left</v-icon>
                                Retour à l'accueil
                            </v-btn>
                        </router-link>
                    </div>
                    <!-- Liste des inscriptions -->
                    <!-- <PreInscriptionsList></PreInscriptionsList> -->
                    <VerifyPreinscriptions></VerifyPreinscriptions>

                </div>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
//import PreInscriptionsList from "@/components/ListPreinscriptions/PreInscriptionsList.vue";
import VerifyPreinscriptions from "@/components/ListPreinscriptions/VerifyPreinscriptions.vue";

export default {
    components: { VerifyPreinscriptions },
    data() {
        return {};
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {},
};
</script>

<style lang="scss" scoped></style>